import { z } from 'zod'
import { oc } from '@orpc/contract'

// The dashboard requests summaries one page at a time (pages of 50), so the
// batch is capped at the page size — the handler never fetches per-row.
export const BILLING_SUMMARIES_MAX_BATCH = 50

// Minimal per-encounter billing summary that backs the dashboard's Billing
// Codes column. Derived from the encounter's Claim (see the handler); an
// encounter with no Claim yields `serviceLineCount: 0` and null codes.
export const billingSummarySchema = z.object({
  encounterId: z.string(),
  firstCode: z.string().nullable(),
  firstModifier: z.string().nullable(),
  serviceLineCount: z.number().int().min(0),
  diagnosisCount: z.number().int().min(0),
})

export const billingSummaries = oc
  .route({ method: 'POST', path: '/v2/billing/summaries' })
  .input(z.object({ encounterIds: z.array(z.string()).max(BILLING_SUMMARIES_MAX_BATCH) }))
  .output(z.object({ summaries: z.array(billingSummarySchema) }))
